import { render, staticRenderFns } from "./ListaSegmento.vue?vue&type=template&id=bc19412a&scoped=true&"
import script from "./ListaSegmento.vue?vue&type=script&lang=js&"
export * from "./ListaSegmento.vue?vue&type=script&lang=js&"
import style0 from "./ListaSegmento.vue?vue&type=style&index=0&id=bc19412a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc19412a",
  null
  
)

export default component.exports